import React, { useState } from 'react';
import { useProducts } from '../context/ProductContext';
import { useNavigate } from 'react-router-dom';

const ProductList = () => {
    const { products, updateProduct } = useProducts();
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');

    const filteredProducts = products.filter(product =>
        product.productName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const toggleStatus = (product) => {
        const newStatus = product.status === 'disabled' ? 'active' : 'disabled';
        updateProduct({ ...product, status: newStatus });
    };

    return (
        <div className="product-list-page">
            <div className="page-header">
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <h2>Product Inventory</h2>
                    <span className="count-badge">{filteredProducts.length} Items</span>
                </div>
                <div className="header-actions">
                    <input
                        type="text"
                        placeholder="Search products..."
                        className="search-input"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button onClick={() => navigate('/add-product')} className="primary-btn">
                        + Add New Product
                    </button>
                </div>
            </div>

            <div className="products-container">
                {products.length === 0 ? (
                    <div className="empty-state">
                        <p>No products found.</p>
                        <span>Start by adding your first product to the catalog.</span>
                    </div>
                ) : (
                    <div className="products-table-container">
                        <table className="products-table">
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Price</th>
                                    <th>Sizes</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredProducts.length > 0 ? (
                                    filteredProducts.map(product => (
                                        <tr key={product.id} className={product.status === 'disabled' ? 'row-disabled' : ''}>
                                            <td>
                                                <div className="product-cell">
                                                    <div className="product-thumb">
                                                        {product.logoUrl ? (
                                                            <img src={product.logoUrl} alt="" />
                                                        ) : (
                                                            <span>Img</span>
                                                        )}
                                                    </div>
                                                    <span className="product-name">{product.productName}</span>
                                                </div>
                                            </td>
                                            <td className="price-cell">₹{product.price}</td>
                                            <td>
                                                <div className="sizes-cell">
                                                    {product.sizes.map(s => (
                                                        <span key={s} className="size-badge">{s}</span>
                                                    ))}
                                                </div>
                                            </td>
                                            <td>
                                                <span className={`status-badge ${product.status === 'disabled' ? 'status-disabled' : 'status-active'}`}>
                                                    {product.status === 'disabled' ? 'Disabled' : 'Active'}
                                                </span>
                                            </td>
                                            <td className="actions-cell">
                                                <button
                                                    className="action-btn"
                                                    onClick={() => navigate(`/add-product?edit=${product.id}`)}
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    className={`action-btn ${product.status === 'disabled' ? 'btn-enable' : 'btn-disable'}`}
                                                    onClick={() => toggleStatus(product)}
                                                >
                                                    {product.status === 'disabled' ? 'Enable' : 'Disable'}
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: 'center', color: '#94a3b8' }}>
                                            No products match your search.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};


export default ProductList;
